import React from "react";
import { ChildAccountsDetailDynamic } from "../../modules/child-accounts-detail/childAccountsDetailDynamic";
import { AddPaymentMethodDynamic } from "../payment-method-new/addPaymentMethodDynamic";
import { PaymentMethodEditDynamic } from "../payment-method-edit/paymentMethodEditDynamic";
import { PaymentInfo } from "../payment/paymentInfo";
import { PaymentDynamic } from "../payment/paymentDynamic";
import { useScreenSubscription } from "./screenProviderLocationAccount";
import { ActiveLocationSubscription } from "./workFlowLocationAccount/activeLocationSubscription";
import { 
  WORK_FLOW_COMMON_SCREENS, 
  WORK_FLOW_LOCATION_ACCOUNT, 
  WORK_FLOW_MASTER_ACCOUNT, 
} from "./const";
import { ActiveMainSubscription } from "./workFlowMasterAccount/activeMainSubscription";
import { MasterAccountSubscription } from "./workFlowMasterAccount/masterAccountSubscription";
import { PurchaseLocation } from "./workFlowLocationAccount/purchaseLocation";
import CreateLocation from "./create-location";

export const WorkFlowSubscription = ({ subscriptionProduct, customerSubInfo }) => {
  const { screen, setSubscriptionProduct, setCustomerSubInfo } = useScreenSubscription();
  React.useEffect(() => {
    setSubscriptionProduct(subscriptionProduct);
  }, [subscriptionProduct, setSubscriptionProduct]);
  React.useEffect(() => {
    setCustomerSubInfo(customerSubInfo);
  }, [customerSubInfo, setCustomerSubInfo]);
  
  return (
    <>
      {screen === WORK_FLOW_MASTER_ACCOUNT.ACTIVE_MAIN_SUBSCRIPTION && 
        <ActiveMainSubscription />
      }
      {screen === WORK_FLOW_MASTER_ACCOUNT.MASTER_ACCOUNT_SUBSCRIPTION && 
        <MasterAccountSubscription />
      }
      {screen === WORK_FLOW_LOCATION_ACCOUNT.ACTIVE_LOCATION_SUBSCRIPTION && 
        <ActiveLocationSubscription />
      }
      {screen === WORK_FLOW_LOCATION_ACCOUNT.LOCATION_ACCOUNT_SUBSCRIPTION && 
        <CreateLocation />
      }
      {screen === WORK_FLOW_LOCATION_ACCOUNT.PURCHASE_LOCATION && 
        <PurchaseLocation />
      }
      {screen === WORK_FLOW_LOCATION_ACCOUNT.CHILD_ACCOUNTS_DETAIL_PAGE && 
        <ChildAccountsDetailDynamic />
      }
      {screen === WORK_FLOW_COMMON_SCREENS.PAYMENT_INFO && 
        <PaymentInfo />
      }
      {screen === WORK_FLOW_COMMON_SCREENS.CARDS &&
        <PaymentDynamic />
      }
      {screen === WORK_FLOW_COMMON_SCREENS.ADD_PAYMENT_METHOD &&
        <AddPaymentMethodDynamic />
      }
      {screen === WORK_FLOW_COMMON_SCREENS.PAYMENT_METHOD_EDIT &&
        <PaymentMethodEditDynamic />
      }
    </>
  );
};
